import translate from '@/lib/intl/translate';
import BulkImportStatus from './BulkImportStatus';

const BulkImportStatusName = Object.freeze({
  [BulkImportStatus.NEW]: translate('DATA_UPLOADS_STATUS_MATCH_HEADERS'),
  [BulkImportStatus.HEADERS_MAPPED]: translate(
    'DATA_UPLOADS_STATUS_GENERATING_REVIEW',
  ),
  [BulkImportStatus.PRE_PROCESSING_DATA]: translate(
    'DATA_UPLOADS_STATUS_GENERATING_REVIEW',
  ),
  [BulkImportStatus.DATA_PRE_PROCESSED]: translate(
    'DATA_UPLOADS_STATUS_READY_FOR_REVIEW',
  ),
  [BulkImportStatus.READY_TO_PROCESS]: translate(
    'DATA_UPLOADS_STATUS_PROCESSING',
  ),
  [BulkImportStatus.PROCESSING_DATA]: translate(
    'DATA_UPLOADS_STATUS_PROCESSING',
  ),
  [BulkImportStatus.DATA_PROCESSED]: translate('DATA_UPLOADS_STATUS_COMPLETED'),
  [BulkImportStatus.EXPIRED]: translate('DATA_UPLOADS_STATUS_EXPIRED'),
  [BulkImportStatus.CANCELED]: translate('DATA_UPLOADS_STATUS_CANCELED'),
  [BulkImportStatus.REVERT]: translate('DATA_UPLOADS_STATUS_REVERT'),
  [BulkImportStatus.REVERTED]: translate('DATA_UPLOADS_STATUS_REVERTED'),
  [BulkImportStatus.REVERTING]: translate('DATA_UPLOADS_STATUS_REVERTING'),
});

export default BulkImportStatusName;
